import { Component, Renderer, OnInit }                          from '@angular/core';

import { Router, ActivatedRoute } 								from '@angular/router';
import { first } 												from 'rxjs/operators';

import { AlertService, AuthenticationService } 					from '../_services';
import { Globals }                                              from '../_helpers';

@Component({
	selector: 'app-text-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit{
	loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg : string;
    returnUrl: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
    ) {}

    ngOnInit() {

        /* get return url from route parameters or default to '/' */
        this.returnUrl = '/';
    }

    public logoutAssessor(){
    	/* reset login status */
        this.authenticationService.logout(this.globals.root_url);
    }

}
